import { TokenTab } from 'pages/token-town';

type TabItem = {
  name: string;
  action: () => void;
};

interface TokenTownTabs {
  tabs: TabItem[];
  activeTab: TokenTab;
}

export const TokenTownTabs = ({ tabs, activeTab }: TokenTownTabs) => {
  const handleTabAction = (e: React.MouseEvent<HTMLElement>, tab: TabItem) => {
    e.preventDefault();
    tab.action();
  };

  return (
    <>
      <div className="tokenTownTabs">
        {tabs.map((tab, i) => {
          return (
            <div
              key={i}
              className={`tabItem ${activeTab === tab.name ? 'selected' : ''}`}
              onClick={(e) => handleTabAction(e, tab)}
            >
              <p>{tab.name}</p>
            </div>
          );
        })}
      </div>
      <style jsx>{`
        .tokenTownTabs {
          display: flex;
          justify-content: space-around;
          width: 100%;
          padding: 0;
          margin-bottom: 0.5em;
        }

        .tabItem {
          display: flex;
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          background-color: #fff;
          border: 3px solid #4a4a4a;
          border-radius: 3px;
          box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.28);
          padding: 1.5em;
          margin: 0 0.3em;
          cursor: pointer;
        }

        .tabItem.selected {
          background-color: #4a4a4a;
          border: none;
          box-shadow: 0px 3px 7px 0px #000000 inset;
        }

        .tabItem:active {
          top: 2px;
          left: 1px;
          box-shadow: none;
        }

        .tabItem p {
          font-size: 0.7em;
          font-family: 'Press Start 2P', 'Montserrat', sans-serif;
          text-transform: uppercase;
        }

        .tabItem.selected p {
          color: #a7fcf7;
        }

        @media (min-width: 700px) {
          .tokenTownTabs {
            padding: 0 6em;
          }

          .tabItem {
            border: 4px solid #4a4a4a;
            padding: 2em;
            margin: 0 1.5em;
          }

          .tabItem p {
            font-size: 1.5em;
          }
        }
      `}</style>
    </>
  );
};
